import React from 'react';

class StoreListItem extends React.Component {


    render() {

        return (

            <div className="c-company-cards__single c-company-cards__single--small" id={this.props.id} onClick={() => this.props.openMainItem(this.props.id)} >
                <div className="c-company-cards__single__info">
                    <address>
                        <h4>{this.props.companyName}</h4>
                        <small>{this.props.street} {this.props.houseNumber}{this.props.houseNumberAdd}, {this.props.zipCode} {this.props.city}</small>
                    </address>
                    <i className="icon-arrow-right"/>
                </div>
                {!!this.props.reviewCount &&
                <div className="c-company-cards__single__score">
                    <div className="c-review-stars">
                        <div className="c-review-stars__wrap">
                            <span>{this.props.averageScore}</span>
                            <div className="c-review-stars__stars"
                                 dangerouslySetInnerHTML={{__html: this.stars(this.props.averageScore)}}/>
                        </div>
                        <small>{this.props.reviewCount} beoordelingen</small>
                    </div>
                </div>
                }
            </div>

        )
    }

    stars = (score) => {
        const starCount = Math.round(score / 2)
        let html = ""
        let i
        for (i = 1; i <= starCount; i++) {
            html += '<i class="icon-star"></i>'
        }
        if (i < 6){
            while (i < 6) {
                html += '<i class="icon-star icon-star--gray"></i>'
                i++
            }
        }
        return html
    }

}

export default StoreListItem
